const Roles = {
    roles: () => 'store/role',
    rolesById: (id: string) => `store/role/${id}`,
}
export default Roles